<template>
  <div
    class="reaction horizontal layout"
  >
    <div
      class="item-reaction count-answer horizontal layout center"
      v-for="item in reactions"
      :key="item.name"
      v-show="presentation[item.type] &&
        presentation.reactions && presentation.reactions[item.name]"
      v-tooltip="presentation[item.type] > 1 ?
        `${formatNumber(presentation[item.type])} ${item.name}s`:
        `${presentation[item.type]} ${item.name}`"
    >
      <div class="item-image-icon horizontal layout center center-justified">
        <img :src="item.iconDefault" alt="">
        <div
          class="img-fly animation"
          v-for="(reaction, index) in item.arrReactions"
          :key="index"
          :class="'animation-' + reaction.indexClass"
        >
          <span class="relative">
            <img :src="item.iconDefault">
            <span
              v-if="reaction.audienceName"
              class="audience-name"
            >{{ reaction.audienceName | profanity }}</span>
          </span>
        </div>
      </div>

      <div class="count-reaction-number">
        <AhaFormatter
          :value="presentation[item.type]"
          :locale="presentation.language"
          type="KMB"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import EventBus from '@/eventBus'
import Util from '@/util'

const heart = require('@/assets/images/reactions/heart-stroke.svg')
const heartDefault = require('@/assets/images/reactions/heart.svg')
const laugh = require('@/assets/images/reactions/laugh-stroke.svg')
const laughDefault = require('@/assets/images/reactions/laugh.svg')
const like = require('@/assets/images/reactions/like-stroke.svg')
const likeDefault = require('@/assets/images/reactions/like.svg')
const sad = require('@/assets/images/reactions/sad-stroke.svg')
const sadDefault = require('@/assets/images/reactions/sad.svg')
const wow = require('@/assets/images/reactions/wow-stroke.svg')
const wowDefault = require('@/assets/images/reactions/wow.svg')

const reactions = [
  {
    name: 'like',
    icon: like,
    iconDefault: likeDefault,
    arrReactions: [],
    type: 'numberOfLikes',
  },
  {
    name: 'heart',
    icon: heart,
    iconDefault: heartDefault,
    arrReactions: [],
    type: 'numberOfHearts',
  },
  {
    name: 'laugh',
    icon: laugh,
    iconDefault: laughDefault,
    arrReactions: [],
    type: 'numberOfLaughs',
  },
  {
    name: 'wow',
    icon: wow,
    iconDefault: wowDefault,
    arrReactions: [],
    type: 'numberOfWows',
  },
  {
    name: 'sad',
    icon: sad,
    iconDefault: sadDefault,
    arrReactions: [],
    type: 'numberOfSads',
  },
]

export default {
  data() {
    return {
      timeout: null,
      reactions,
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      slideActive: (state) => state.slideActive,
    }),
  },
  created() {
    EventBus.$off('create-reaction')
  },
  beforeDestroy() {
    this.clearReactionsFly()
    if (this.timeout) clearTimeout(this.timeout)
    this.timeout = null
  },
  mounted() {
    EventBus.$on('create-reaction', ({ audienceName, reactionType }) => {
      const item = {
        id: new Date().getTime(),
        indexClass: Math.floor(Math.random() * 8) + 1,
        audienceName,
      }
      const index = this.reactions.findIndex((reaction) => {
        return reaction.name === reactionType
      })

      if (index === -1) return
      this.reactions[index].arrReactions.push(item)
      if (this.timeout) {
        clearTimeout(this.timeout)
        this.timeout = null
      }

      this.timeout = setTimeout(() => {
        this.clearReactionsFly()
        this.timeout = null
      }, 5000)
    })
  },
  methods: {
    formatNumber: Util.formatNumber,
    clearReactionsFly() {
      this.reactions = this.reactions.map((reaction) => {
        reaction.arrReactions = []
        return reaction
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.reaction {
  margin-right: 4px;
  .count-reaction-number {
    padding-left: 4px;
    cursor: pointer;
    span {
      vertical-align: middle;
    }
  }
  .item-reaction {
    margin-left: 8px;
    &:first-child {
      margin-left: 0;
    }
    cursor: pointer;
    .item-image-icon {
      cursor: pointer;
      position: relative;
      width: 23px;
      height: 23px;

      img {
        width: 23px;
        height: 23px;
      }

      .img-light {
        display: none;
      }
      .img-fly {
        pointer-events: none;

        .audience-name {
          position: absolute;
          top: 0;
          font-size: 10px;
          text-transform: capitalize;
          width: 200px;
          left: 0;
          margin-left: 27px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          animation-name: audience-name;
          animation-duration: 5s;
          line-height: 24px;
          opacity: 0.6;
        }
      }
    }
  }

  &.white {
    .item-image-icon {
      &::after {
        background-color: rgba(255, 255, 255, 0.1);
      }
    }
  }
}

.animation-1 {
  animation: opacity-7 4s linear 0s 1 normal forwards,
    position-3 5s linear;
}
.animation-2 {
  animation: opacity-2 4s linear 0s 1 normal forwards,
    position-8 5s linear;
}
.animation-3 {
  animation: opacity-5 4s linear 0s 1 normal forwards,
    position-5 5s linear;
}
.animation-4 {
  animation: opacity-1 4s linear 0s 1 normal forwards,
    position-4 5s linear;
}
.animation-5 {
  animation: opacity-4 4s linear 0s 1 normal forwards,
    position-2 5s linear;
}
.animation-6 {
  animation: opacity-8 4s linear 0s 1 normal forwards,
    position-6 5s linear;
}
.animation-7 {
  animation: opacity-3 4s linear 0s 1 normal forwards,
    position-7 5s linear;
}
.animation-8 {
  animation: opacity-6 4s linear 0s 1 normal forwards,
    position-1 5s linear;
}

.animation {
  position: absolute !important;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  display: flex;
  z-index: 88 !important;
  // backface-visibility: hidden;

  &.fa-heart {
    color: rgb(243, 81, 134);
  }
  &.fa-grin-squint {
    color: #FFC700;
  }
  &.fa-question-circle {
    color: rgb(111, 151, 247);
  }
  &.fa-thumbs-up {
    color: #28C270;
  }
  &.fa-thumbs-down {
    color: rgb(255, 103, 103);
  }
}
.item-reaction.count-answer {
  cursor: auto;
}

@keyframes audience-name {
  0% {
    opacity: 0;
  }
  14% {
    opacity: 0.6;
  }
  100% {
    opacity: 0.6;
  }
}

@keyframes position-1 {
  0% {
    transform: translate(0) scale(1);
  }
  20% {
    transform: translate(-0.4vw, -9.2vh) scale(1);
  }
  80% {
    transform: translate(-1.6vw, -36.2vh) scale(1.3);
  }
  100% {
    transform: translate(-2vw, -46vh) scale(0);
  }
}
@keyframes position-2 {
  0% {
    transform: translate(0) translateY(1);
  }
  20% {
    transform: translate(-2.2vw, -9.4vh) scale(1);
  }
  80% {
    transform: translate(-8.8vw, -37.6vh) scale(1.3);
  }
  100% {
    transform: translate(-11vw, -47vh) scale(0);
  }
}

@keyframes position-3 {
  0% {
    transform: translate(0);
  }
  20% {
    transform: translate(-1.4vw, -9.6vh) scale(1.3);
  }
  80% {
    transform: translate(-5.6vw, -38.4vh) scale(1.2);
  }
  100% {
    transform: translate(-7vw, -48vh) scale(0);
  }
}
@keyframes position-8 {
  0% {
    transform: translate(0);
  }
  20% {
    transform: translate(1.2vw, -9.4vh) scale(1.3);
  }
  80% {
    transform: translate(4.8vw, -37.6vh) scale(1.1);
  }
  100% {
    transform: translate(6vw, -47vh) scale(0);
  }
}

@keyframes position-5 {
  0% {
    transform: translate(0);
  }
  20% {
    transform: translate(1.8vw, -10vh) scale(1);
  }
  80% {
    transform: translate(7.2vw, -40vh) scale(1.2);
  }
  100% {
    transform: translate(9vw, -50vh) scale(0);
  }
}

@keyframes position-4 {
  0% {
    transform: translate(0);
  }
  20% {
    transform: translate(1.4vw, -8.2vh) scale(1.2);
  }
  80% {
    transform: translate(5.6vw, -32.8vh) scale(1.4);
  }
  100% {
    transform: translate(7vw, -41vh) scale(0);
  }
}
@keyframes position-6 {
  0% {
    transform: translate(0);
  }
  20% {
    transform: translate(-0.4vw, -9.8vh) scale(1.4);
  }
  80% {
    transform: translate(-1.6vw, -39.2vh) scale(1.3);
  }
  100% {
    transform: translate(-2vw, -49vh) scale(0);
  }
}
@keyframes position-7 {
  0% {
    transform: translate(0);
  }
  20% {
    transform: translate(-1.8vw, -9.6vh) scale(1.6);
  }
  80% {
    transform: translate(-7.2vw, -38.4vh) scale(1.4);
  }
  100% {
    transform: translate(-9vw, -48vh) scale(0);
  }
}

@keyframes opacity-1 {
  0% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes opacity-2 {
  0% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes opacity-3 {
  0% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes opacity-4 {
  0% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes opacity-5 {
  0% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes opacity-6 {
  0% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes opacity-7 {
  0% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes opacity-8 {
  0% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

</style>
